<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="dialogTitle" width="800" draggable>
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-form-item :label="t('attendanceDialog.locationName')" prop="location_name">
                        <el-input v-model="state.form.location_name" :placeholder="t('common.pleaseInput')" />
                    </el-form-item>
                    <el-form-item :label="t('attendanceDialog.locationDesc')" prop="description">
                        <el-input v-model="state.form.description" type="textarea" :placeholder="t('common.pleaseInput')" :rows="5" />
                    </el-form-item>
                    <el-form-item :label="t('field.status')" prop="status">
                        <el-switch
                            v-model="state.form.status"
                            :active-value="1"
                            :inactive-value="0"
                            :active-text="t('status.enabled')"
                            :inactive-text="t('status.disabled')"
                        />
                    </el-form-item>
                    <el-form-item :label="t('attendance.longitude')" prop="longitude">
                        <el-input v-model.number="state.form.longitude" style="width: 200px;" />
                        <el-button type="primary" @click="toBaiDuMap()" style="margin-left: 10px;">{{ t('attendanceDialog.openGoogleMaps') }}</el-button>
                    </el-form-item>
                    <el-form-item :label="t('attendance.latitude')" prop="latitude">
                        <el-input v-model.number="state.form.latitude" style="width: 200px;" />
                    </el-form-item>
                    <el-form-item :label="t('attendanceDialog.selectAddress')">
                        <Map @change="getAddressInfo" />
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <el-button @click="close">{{ t('common.cancel') }}</el-button>
                <el-button type="primary" @click="submit">{{ t('common.confirm') }}</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, ref, defineEmits, defineProps, defineExpose, computed, toRaw } from "vue";
import { ElMessage } from "element-plus";
import Map from "@/components/map/index.vue";
import { saveApi, detailApi } from "@/api/attendance/clockin";
import { usePageI18n, t } from "@/composables/usePageI18n.js";

const emit = defineEmits(['refresh']);
const props = defineProps({
    title: { type: String, default: '' },
});

const dialogTitle = computed(() => props.title || t('attendanceDialog.clockLocationTitle'));

const state = reactive({
    dialogVisible: false,
    form: { id: 0, location_name: "", description: "", latitude: "", longitude: "", status: 1 },
});

const validLongitude = (rule, value, callback) => {
    const num = Number(value);
    if (num < -180 || num > 180) callback(new Error(t('attendanceDialog.longitudeRange')));
    else callback();
};
const validLatitude = (rule, value, callback) => {
    const num = Number(value);
    if (num < -90 || num > 90) callback(new Error(t('attendanceDialog.latitudeRange')));
    else callback();
};

const rules = computed(() => ({
    longitude: [
        { required: true, message: t('attendanceDialog.enterLongitude'), trigger: 'blur' },
        { validator: validLongitude, trigger: 'change' },
    ],
    latitude: [
        { required: true, message: t('attendanceDialog.enterLatitude'), trigger: 'blur' },
        { validator: validLatitude, trigger: 'change' },
    ],
}));

const toBaiDuMap = () => {
    const { longitude, latitude } = state.form;
    const url = longitude && latitude
        ? `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
        : 'https://www.google.com/maps';
    window.open(url, '_blank');
};

const open = (row = {}) => {
    if (row?.id) {
        detailApi(JSON.stringify({ id: row.id })).then(res => {
            if (res?.code !== 200) return;
            state.form = { ...res.data, location_name: res.data.locationName };
        });
    } else {
        state.form.id = 0;
    }
    state.dialogVisible = true;
};

const close = () => {
    state.dialogVisible = false;
    state.form = { id: 0, location_name: "", description: "", latitude: "", longitude: "", status: 1 };
};

const getAddressInfo = (val) => {
    state.form.longitude = val.lng;
    state.form.latitude = val.lat;
    state.form.location_name = val.address;
};

const ruleForm = ref(null);

const submit = () => {
    ruleForm.value.validate((valid) => {
        if (!valid) return false;
        saveApi(JSON.stringify({
            ...toRaw(state.form),
            latitude: Number(state.form.latitude),
            longitude: Number(state.form.longitude),
        })).then(res => {
            if (res?.code === 200) {
                ElMessage.success(t('common.success'));
                close();
                emit('refresh');
            }
        });
    });
};

usePageI18n(() => {});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}
.userFrom {
    display: grid;
    gap: 20px;
}
</style>
